import React from "react";
import { Link } from "react-router-dom";

const Privacy = () => {
  const getBackUrl = () => {
    if (!localStorage.getItem('is_authenticated')) return '/';
    try {
      const type = JSON.parse(localStorage.getItem('userData') || '{}').userType;
      if (type === 'restaurant') return '/restaurant/dashboard';
      if (type === 'staff') return '/restaurant-staff/employee';
      if (type === 'admin') return '/admin/dashboard';
      if (type === 'vendor') return '/vendor/dashboard';
      if (type === 'customer') return '/customer';
    } catch (e) {}
    return '/';
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg p-8 md:p-12 space-y-8">
        
        <div className="flex justify-between items-center border-b border-gray-100 pb-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">Privacy Policy</h1>
            <p className="text-sm text-gray-500 mt-2">Last Updated: June 2026</p>
          </div>
          <Link to={getBackUrl()} className="text-primary hover:underline font-medium text-sm">
            &larr; Back to App
          </Link>
        </div>

        <div className="space-y-8 text-gray-600 leading-relaxed text-sm md:text-base">
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-primary">•</span> 1. Information Collection
            </h2>
            <p className="pl-4 border-l-2 border-gray-100">
              This is a placeholder Privacy Policy. Stellaris collects information to provide better services to its users. We collect data you provide directly to us, such as when you create an account, update your profile, or use our interactive features.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-primary">•</span> 2. Use of Information
            </h2>
            <div className="pl-4 border-l-2 border-gray-100">
              <p className="mb-2">The information we collect is used in the following ways:</p>
              <ul className="list-disc pl-5 space-y-2 text-gray-500">
                <li>To provide, maintain, and improve our services.</li>
                <li>To process transactions and send related information securely.</li>
                <li>To monitor and analyze trends and usage across the platform.</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-primary">•</span> 3. Data Sharing
            </h2>
            <p className="pl-4 border-l-2 border-gray-100">
              We do not share your personal information with third parties except as described in this policy. We may share information with trusted vendors, consultants, and service providers who need access to such information to carry out work on our behalf.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-primary">•</span> 4. Data Security
            </h2>
            <p className="pl-4 border-l-2 border-gray-100">
              We take reasonable measures to help protect your personal information from loss, theft, misuse, and unauthorized access. However, no internet transmission is completely secure.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-primary">•</span> 5. Your Rights
            </h2>
            <p className="pl-4 border-l-2 border-gray-100">
              Depending on your location, you may have the right to access, correct, or delete your personal data. This is a placeholder clause designed for layout purposes.
            </p>
          </section>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-100 text-center">
          <button onClick={() => window.history.back()} className="px-6 py-2 bg-primary text-white font-medium rounded shadow hover:bg-opacity-90 transition-all">
            Acknowledge & Return
          </button>
        </div>

      </div>
    </div>
  );
};

export default Privacy;
